import { Component } from '@angular/core';
import { fadeAnimation } from '../../../core/animations/fade.animation';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-home-page',
  animations: [fadeAnimation],
  template: `
    <app-page-section>
      <div class="flex lg:gap-20">
        <div class="w-full flex-none md:w-[60%] lg:w-1/2">
          <h1
            >Un outil complet <br class="hidden lg:inline" />pour la location de
            salles</h1
          >
          <p class="mt-6"
            >Vous êtes une commune, une entreprise ou un espace co-working
            souhaitant louer des salles? La mission de notre outil
            location-salles.ch est de faciliter les processus admin chronophages
            et coûteux, et de proposer une solution moderne et accessible à vos
            clients afin d'augmenter votre volume de locations.</p
          >
          <div class="mt-6 flex flex-wrap gap-5 xl:mt-10">
            <app-button variant="primary" routerLink="/auth/devenir-un-hote"
              >Devenir hôte</app-button
            >
            <app-button
              variant="outlined"
              [routerLink]="['/a-propos']"
              >Découvrir</app-button
            >
          </div>
        </div>
        <div class="hidden flex-none grow md:block">
          <div class="-mt-20 w-full overflow-hidden md:w-[900px]">
            <img
              class="w-full"
              ngSrc="header.webp"
              priority
              width="1000"
              height="669"
              sizes="50vw"
              alt="Présentation de location-salles.ch"
              title="Présentation de location-salles.ch"
            />
          </div>
        </div>
      </div>
    </app-page-section>

    <app-page-section
      [noContainer]="true"
      [waves]="true"
      backgroundColor="secondary"
      offsetImage="cactus.png"
      id="features"
    >
      <div class="container">
        <div
          class="flex flex-col items-center justify-center space-y-2 text-white"
        >
          <div class="relative -left-[120px] flex space-x-2">
            <i class="fal fa-stars text-white"></i>
            <div class="mt-2.5 h-px w-16 bg-white"></div>
          </div>
          <h2>Fonctionnalités</h2>
        </div>
        <div
          class="mt-20 flex flex-col flex-wrap justify-center gap-x-16 gap-y-20 lg:flex-row"
        >
          <app-feature
            img="/assets/img/features/location-equipements.svg"
            title="Location d'équipements"
            description="vos clients louent ceux-ci en supplément de leur réservation"
          ></app-feature>

          <app-feature
            img="/assets/img/features/paiement-en-ligne.svg"
            title="Facturation automatique"
            description="grâce au paiement en ligne via carte de crédit et TWINT"
          ></app-feature>

          <app-feature
            img="/assets/img/features/reservation-en-ligne.svg"
            title="Gestion des réservations"
            description="approuvez ou refusez les demandes de vos clients"
          ></app-feature>

          <app-feature
            img="/assets/img/features/automatisation-conditions-annulation.svg"
            title="Annulation autonome"
            description="remboursement direct selon vos conditions"
          ></app-feature>

          <app-feature
            img="/assets/img/features/gestion-utilisateurs.svg"
            title="Location interne/externe"
            description="définissez qui peut réserver ou non certaines salles"
          ></app-feature>

          <app-feature
            img="/assets/img/features/gestion-groupes-tarifaires.svg"
            title="Création de bons de réduction"
            description="pour vos clients spéciaux, groupes ou sociétés"
          ></app-feature>

          <app-feature
            [new]="true"
            img="/assets/img/features/dormakaba.svg"
            title="Intégration dormakaba"
            description="ouverture de porte autonome"
            logo="features/logo-dormakaba.png"
          ></app-feature>

          <app-feature
            [new]="true"
            img="/assets/img/features/gestion-salles.svg"
            title="Groupes de salles"
            description="location d'espaces liés qui se bloquent automatiquement"
          ></app-feature>
        </div>
      </div>
    </app-page-section>

    <app-page-section padding="lg">
      <div class="grid items-center gap-8 md:grid-cols-2 md:gap-16">
        <div class="order-1 col-span-1 md:order-0 md:flex md:justify-end">
          <img
            class="max-h-[500px] w-auto"
            ngSrc="keyboard.webp"
            width="1076"
            height="1070"
            sizes="(max-width: 768px) 80vw, 25vw"
            alt="Clavier"
          />
        </div>
        <div class="order-0 col-span-1 md:order-1">
          <div class="relative flex items-center gap-3">
            <div class="bg-secondary-500 h-px w-16"></div>
            <i class="fal fa-shuffle"></i>
          </div>
          <h2 class="mt-5">Découvrez comment<br />notre produit est utilisé</h2>
          <p class="mt-4"
            >Quelques fonctionnalités détaillées et exemples de clients vous
            permettront d’en apprendre un peu plus sur la solution web
            location-salles.ch.</p
          >
          <div class="mt-8">
            <app-button [routerLink]="['/a-propos']" icon="arrow-right"
              >À propos</app-button
            >
          </div>
        </div>
      </div>
    </app-page-section>

    <app-page-section
      backgroundColor="neutral"
      [noContainer]="true"
      padding="lg"
    >
      <div class="mx-auto justify-center text-center md:w-[400px]">
        <div class="relative pt-16 md:pt-0">
          <img
            class="absolute -top-40 left-4 w-64 md:-top-72 md:-left-72 md:w-96"
            ngSrc="coffee-clipboard.png"
            width="1002"
            height="939"
            alt="location-salles.ch - café"
            title="location-salles.ch - café"
          />

          <div class="absolute top-20 right-4 md:-top-8 md:-right-6">
            <div class="flex items-center space-x-3">
              <div class="bg-secondary-500 h-px w-16"></div>
              <i class="fal fa-bullseye-arrow"></i>
            </div>
            <div
              class="bg-secondary-500 absolute right-2 mt-3 ml-1.5 h-32 w-px"
            ></div>
          </div>

          <div class="mt-10 mr-10 text-right md:mt-0 md:mr-3">
            <div class="text-right text-2xl font-bold"
              >Une solution développée en collaboration avec nos clients</div
            >
            <div class="mt-4">
              <app-public-tag
                >pour une réponse ciblée des besoins</app-public-tag
              >
            </div>
          </div>
        </div>
      </div>
    </app-page-section>
  `,
  standalone: false,
})
export class HomePageComponent {
  constructor(private title: Title) {
    this.title.setTitle(
      'Location de salles - Outil complet de réservation de salles pour les entreprises et les communes',
    );
  }
}
